export default __webpack_public_path__ + "static/media/docks1.b3f141e1.mp4";